import {StandardName} from "./order.state";
import {QuestionGroup} from "./checklist-common";

export interface OrderReviewChecklist {
	orderCorrelationId: string;
	acceptanceDate: Date;
	acceptanceBy: string;
	declineDate: Date;
	questionGroups: QuestionGroup[];
	preReviewerMessage: PreReviewerMessage;
	checkListAcceptanceDate: Date;
	checkListAcceptanceBy: string;
	reviewerChangeComment: string;
}

export interface TransferOrderReviewChecklist extends OrderReviewChecklist {
	previousCBConfirmations: PreviousCbConfirmation[];
}

export interface PreviousCbConfirmation {
	standardName: StandardName;
	cbName: string;
	enquirySendDate: Date;
	noAnswerFromCB: boolean;
	answer: string;
	answerFile: UploadedAnswer;
	email: string;
	certificateNumber: string;
	emailPreview: string;
	sentEmailSnapshot: string;
}

export interface UploadedAnswer {
	fileUuid: string;
	fileName: string;
	md5: string;
}

export interface PreReviewerMessage {
	message: string;
	createdAt: Date;
	createdBy: string;
}

export enum ChecklistType {
	APPLICATION_REVIEW = 'APPLICATION_REVIEW'
}
